// extracted by mini-css-extract-plugin
export default {"wrap":"toast_stack_wrap__AK+EJ","inner":"toast_stack_inner__Ggsq3"};